import { apiClient } from '../lib/apiClient';

export interface TaskItem {
  id: string;
  _id?: string;
  title: string;
  description?: string;
  type: string;
  status: string;
  priority: string;
  assignedTo: any;
  assignedBy: any;
  book?: any;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
}

export const tasksApi = {
  async list(params: any = {}): Promise<{ tasks: TaskItem[]; pagination: any }> {
    const res = await apiClient.get('/api/tasks', { params: { page: 1, limit: 1000, ...params } });
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to load tasks');
    return { tasks: res.data?.data?.tasks || [], pagination: res.data?.data?.pagination || null };
  },
  async get(id: string): Promise<any> {
    const res = await apiClient.get(`/api/tasks/${id}`);
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to load task');
    return res.data?.data;
  },
  async create(payload: any): Promise<TaskItem> {
    const res = await apiClient.post('/api/tasks', payload);
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to create task');
    return res.data?.data;
  },
  async update(id: string, payload: Partial<TaskItem>): Promise<TaskItem> {
    const res = await apiClient.patch(`/api/tasks/${id}`, payload);
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to update task');
    return res.data?.data;
  },
  async delete(id: string): Promise<void> {
    const res = await apiClient.delete(`/api/tasks/${id}`);
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to delete task');
  },
  async requestTransfer(id: string, toUserId: string, note?: string): Promise<TaskItem> {
    const res = await apiClient.post(`/api/tasks/${id}/request-transfer`, { toUserId, note });
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to request transfer');
    return res.data?.data;
  },
  async approveTransfer(id: string): Promise<TaskItem> {
    const res = await apiClient.post(`/api/tasks/${id}/approve-transfer`, {});
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to approve transfer');
    return res.data?.data;
  },
  async replyTransfer(id: string): Promise<TaskItem> {
    const res = await apiClient.post(`/api/tasks/${id}/reply-transfer`, {});
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to reply');
    return res.data?.data;
  },
  async complete(id: string): Promise<TaskItem> {
    const res = await apiClient.post(`/api/tasks/${id}/complete`, {});
    if (!res.data?.ok) throw new Error(res.data?.error?.message || 'Failed to complete task');
    return res.data?.data;
  }
};
